/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

const glitchEffect = () => {
    const $li = $('.Header__MainNav').find('ul li:first').find('a'),
      $div = $('.SidebarMenu__Nav').find('div:first-of-type').find('a');

    $li.data('text', 'SECRET SALE').attr('data-text', 'SECRET SALE').addClass('glitch');
    $div.data('text', 'SECRET SALE').attr('data-text', 'SECRET SALE').addClass('glitch');
}

const equaliser = ($equaliserSelector) => {
  let maxHeight = 0;
  $equaliserSelector.each((index, selector) => {
      const isCarouselItem = $(selector).closest('.Carousel__Cell').length;

      if ($(selector).outerHeight() > maxHeight) {
          maxHeight = $(selector).outerHeight();
      }
  }).height(maxHeight);

  maxHeight = 0;
}

const eqs = () => {
  equaliser($('.glimpse-block-title'));
}

jQuery('body').find('.js-glimpse-subscribe-newsletter').on('submit', (e) => {
  e.preventDefault();
  let myHeaders = new Headers(),
      urlencoded = new URLSearchParams();

  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  urlencoded.append("g", "R6rMDr");
  urlencoded.append("$fields", "email");
  urlencoded.append("email", jQuery('body').find('.js-glimpse-subscribe-newsletter input[type="email"]').val());

  const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
  };

  fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", requestOptions)
    .then(response => {
      if (response.status === 200) {
          $.when(
              jQuery('body').find('.js-glimpse-subscribe-newsletter').fadeOut()
          ).done(() => {
              jQuery('.js-successmail').html('Thanks for signign up.').fadeIn();
          })
      } else {
        jQuery('.js-successmail').html('There was an issue signing you up. Please Try again.').fadeIn();
      }
  })
});
jQuery('body').find('.js-glimpse-custom-add-to-cart').off('click').on('click', (e) => {
    e.preventDefault();
    const product = $(e.currentTarget),
        productId = product.data('product_id'),
        variantId = product.data('variant_id'),
        dataToSend = {form_type: "product", id: variantId, "product-id": productId, quantity: 1, utf8: '✓'};
        
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: dataToSend,
        dataType: 'json'
    }).done((data) => {
        if (data && data.id && data.id === variantId) {
            document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: data,
                  quantity: 1
            }}));
        }
    });
});

jQuery(document).ready(() => {
  eqs();
});

jQuery($(window)).on('resize', () => {
  eqs();
});